import React from 'react';
import PropTypes from 'prop-types';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import {
  RemoveBagButton, AddBagButton, Selector, Container, Title, Number,
} from './style';

const removeBag = (form, field) => (field.value > 1
  ? form.setFieldValue(field.name, field.value - 1)
  : null);

const addBag = (form, field) => form.setFieldValue(field.name, field.value + 1);

const BagSelector = ({ field, form }) => (
  <Container>
    <Title>Number of bags</Title>
    <Selector>
      <Number>{field.value}</Number>
      <RemoveBagButton onClick={() => removeBag(form, field)}>
        <RemoveIcon />
      </RemoveBagButton>
      <AddBagButton onClick={() => addBag(form, field)}>
        <AddIcon />
      </AddBagButton>
    </Selector>
  </Container>
);

BagSelector.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.number,
  }).isRequired,
  form: PropTypes.shape({}).isRequired,
};

export default BagSelector;
